"use client";

import { useEffect, useRef } from "react";

import { type CategoryProducts } from "@/app/blu/shop/actions";
import {
  EVENTS,
  FLOW_TYPE,
  FLOW_TYPE_PARTNER,
  PAGE,
} from "@/constants/analytics.constants";
import { useTagging } from "@/hooks/useTagging";

export type ProductSearchEventOptions = {
  itemListId?: string;
  itemListName?: string;
};

export const useProductSearchEvent = (
  search: string,
  products: CategoryProducts,
  options?: ProductSearchEventOptions,
) => {
  const [, setTag] = useTagging();
  const lastSearchRef = useRef("");

  useEffect(() => {
    if (!search?.trim()) {
      lastSearchRef.current = "";
      return;
    }

    if (search === lastSearchRef.current) return;
    lastSearchRef.current = search;

    const listId = options?.itemListId ?? PAGE.BLU_PDP;

    const items = (products ?? []).map((product, index) => ({
      id: product.id ?? "",
      item_name: (product.name ?? "").trim(),
      price: product.salesPrice ?? product.listPrice ?? 0,
      item_list_id: listId,
      item_list_name: options?.itemListName ?? (product.name ?? "").trim(),
      index,
    }));

    setTag({
      event: EVENTS.PDP_PRODUCT_SEARCH,
      ecommerce: {
        ecomm_flow_type: FLOW_TYPE.BLU_DIY,
        ecomm_flow_type_partner: FLOW_TYPE_PARTNER.ADT,
        product_search_term: search,
        product_search_result_number: String(items.length),
        items,
      },
    });
  }, [search, products, setTag]);
};
